// import LocalizedStrings from 'react-localization';
import { getStrings } from '../../Common/Localization/commonStrings';

const localizedStrings = {
  myAccountContainer: {
    strings: { en: {}, es: {}},
    common: ['globalError']
  },
  multipleAccountContainer: {
    strings: {
      en: {
        viewBillErr: 'Please be aware that enrolling in Paperless billing will stop paper from being sent to your company\'s Accounts Payable location or payment agent.\n\nPlease be sure that this change has been approved by the person responsible for paying your company\'s bill prior to enrolling.',
        billUnavailableErr: 'Your bill is not available at this time.',
        billObInEligibleErr: 'This account is ineligible because it is already signed up for Paperless Billing with another user.',
        oBIneligible: 'ObIneligible',
        oBEnroll: 'ObEnroll',
        oPIneligible: 'OpIneligible',
        dPIneligible:'DpIneligible',
        dPDeEnroll: 'DpDeEnroll',
        oPDeEnroll: 'OpDeEnroll',
        payNowSingleAccErr: 'This account is currently signed up for Auto Pay and will need to be cancelled in order to complete your sign up for Online Payment.\n\nDo you want to continue with sign up?',
        flag_Y: 'Y',
        yes_IWantToContinue: 'Yes, I want to continue',
        no_notAtThisTime: 'No, not at this time',
        customerAccountData: 'customerAccountData',
        customerAccountType: 'customerAccountType',
        billUnavailableErr1: 'Your bill is not yet available. If you’re enrolled in Online Billing notifications, we’ll send you an email when it’s ready. Otherwise, please try again later.',
        billUnavailableErr2: 'We’re sorry, but due to a system issue, your bill is temporarily unavailable for viewing. We’re working to resolve the issue as soon as possible. Please try again later. Error Code ',
        openText1: 'Open Text_1',
        openText100: 'Open Text_100',
        openText200: 'Open Text_200',
        openText250: 'Open Text_250',
        openText700: 'Open Text_700',
        openText800: 'Open Text_800',
        openText900: 'Open Text_900',
        openText1000: 'Open Text_1000',
        openText2000: 'Open Text_2000',
        openText3000: 'Open Text_3000'
      },
      es: {
      }
    },
    common: ['yes', 'no']
  },
  accountsOverviewComponent: {
    strings: {
      en: {
        sortByCustNameAsc: 'Customer Name - Ascending',
        sortByCustNameDesc: 'Customer Name - Descending',
        sortByCustNumAsc: 'Customer Account Number - Ascending',
        sortByCustNumDesc: 'Customer Account Number - Descending',
        bannerMessage: 'My Account Overview',
        viewBillingHeading: 'View Billing & Usage on ',
        viewBillingHeading2: ' All Your Accounts',
        /************************
        Change type : No.of accounts message change in Single Account and Multi account view
        Changed by: Jitendra D
        Date : 30-06-2020
        ************************/
        noOfAccountsDisplayed: ' accounts displayed. Select View/Manage Accounts to add or remove accounts to your My Account Overview page.',
        viewManageBtn: 'View/Manage Accounts',
        goToBnpBtn: 'Go to Billing & Payments',
        enrollInDigitalNotificationsBtn:'Enroll in Digital Notifications',
        noOfCactsText: ' Customer Accounts available',
        searchPlaceholder: 'Filter by Account #',
        sortLabel: 'Sort by:',
        emptySearchInputError: 'Please enter your valid account number',
        billQuestions: 'Bill Help'
      },
      es: {
      }
    },
    common: []
  },
  customerAccountComponent: {
    strings: {
      en: {
        payNowBtn: 'Pay Now',
        sceAccountRepBtn: 'SCE Account Rep',
        showMoreLink: 'Show More',
        viewBillLink: 'View Bill',
        downloadBillLink: 'PDF Bill',
        viewDetailsLabel: 'View Details',
        detailsLink: 'Details',
        requestPALink: 'Request Payment Arrangement',
        delayedBilling: 'Due to a delay in your account billing, your usage details will not be available. Please try again later.',
        pendingtxt: 'You have a pending payment',
        edit: 'edit'
      },
      es: {}
    }, common: []
  },
  serviceAccOverviewComponent: {
    strings: {
      en: {
        OBWarning: 'Please be aware that enrolling in Paperless billing will stop paper from being sent to your company\'s Accounts Payable location or payment agent.\n\n Please be sure that this change has been approved by the person responsible for paying your company\'s bill prior to enrolling.',
        setBudgetLink: 'Set Budget ',
        editUnenrollLink: 'Edit Spending Goal',
        projectedBill: 'Projected Next Bill: ',
        viewDetailsLink: 'View Details',
        viewUsageBtn: 'View Usage',
        budgetassistantunenroll: 'Budget Assistant Unenroll',
        viewProjectedUsageLink: 'View Projected Usage ',
        supply:'Supply/Generation ',
        delivery:'Delivery ',
        billedGeneration:'Billed Generation Charge',
        active:'Active',
        inActive:'Inactive',
        pending:'Pending',
        accountStatus:'Account Status: ',
        podIdInfoDescpt:"This is an additional customer identification field for your reference for billing inquiries. The POD ID can also be located near your Service Account number on your bill.",
        learnMore:'Learn more',
        moveInDate:'Move In Date:',
        moveOutDate:'Move Out Date:'
      },
      es: {}
    },
    common: []
  }
};

export const getLocalizedStrings = (componentName) => {
  // app.logger.getLogger().info('Comp Name' + componentName);
  var strings = getStrings(localizedStrings[componentName].strings,
    localizedStrings[componentName].common, true);
  return strings;
  // return new LocalizedStrings(strings);
};
